import type { Asset, Entry } from '~/diptyqueTheme/types/contentful';

declare module 'contentful' {
  interface Asset {
    contentType?: string;
    url?: string;
    height?: number;
    width?: number;
  }
}

const capitalizeFirstLetter = (str: string) => {
  if (!str || typeof str !== 'string') return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const processEntry = (e) => {
  const _entry = e?.fields ? e.fields : e;
  if (!_entry) return null;

  for (const key in _entry) {
    if (key === 'sys') {
      // Do nothing
    } else if (typeof _entry[key] === 'object' && !Array.isArray(_entry[key])) {
      _entry[key] = toGQLFormat(_entry[key]);
    } else if (Array.isArray(_entry[key]) && _entry[key][0]?.sys?.type === 'Entry') {
      _entry[key + 'Collection'] = {
        items: _entry[key]
          .map((item) => toGQLFormat(item))
          .filter((i) => {
            return i !== null;
          })
      };
      delete _entry[key];
    }
  }

  const unknownTypename = 'Unknown (hint: add contentType data into ~/integrations/contentful/src/config/contentTypes.ts)';
  _entry.__typename = capitalizeFirstLetter(e?.sys?.contentType?.sys?.id) || unknownTypename;
  if (e?.sys?.id) _entry.sys = { id: e.sys.id };

  return _entry;
};

const processAsset = (a) => {
  const file = a?.fields?.file || {};
  if (file.contentType) a.contentType = file.contentType;
  if (file?.url) a.url = file.url?.[0] === '/' ? 'https:' + file.url : file.url;
  if (file.details?.image?.height) a.height = file.details.image.height;
  if (file.details?.image?.width) a.width = file.details.image.width;

  return a;
};

// Convert object structure to GraphQL response format
// To provide compatibility with previous GraphQL requests approach
// as current sections components are built relying on GraphQL response
// TODO: i.sprut refactoring needed
export default function toGQLFormat(obj: Asset | Entry) {
  let res = obj;

  if (typeof obj === 'object' && !Array.isArray(obj)) {
    if (obj.sys?.type === 'Entry') {
      res = processEntry(obj);
    } else if (obj.sys?.type === 'Asset') {
      res = processAsset(obj);
    }
  }

  return res;
}
